module.exports = __webpack_public_path__ + "img/4A.4e6f3773.jpg";